import { styled, Container, Paper } from '@mui/material';
import ProfileCard from 'components/ProfileCard';

export const StyledContainer = styled(Container)`
  position: relative;

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-top: 3rem;
    margin-bottom: 1rem;
    max-width: 880px;
  }
`;

export const StyledPaper = styled(Paper)`
  border-radius: ${({ theme }) => theme.radius?.lg};
  padding: 0 0 1rem;
  height: 100%;
  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: 1rem;
  }
`;

export const StyledProfileCard = styled(ProfileCard)`
  margin-left: 1rem;
  margin-right: 1rem;

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin: 0.5rem 0;
  }
`;
